import apiClient from './apiClient';

export const objektApi = {
  getByKunde: (kundeId) => apiClient.get(`/objekte/kunde/${kundeId}`),
  getById: (id) => apiClient.get(`/objekte/${id}`),
  create: (data) => apiClient.post('/objekte', data),
  update: (id, data) => apiClient.put(`/objekte/${id}`, data),
  delete: (id) => apiClient.delete(`/objekte/${id}`),

  createAnsprechpartner: (data) => apiClient.post('/objekte/ansprechpartner', data),
  updateAnsprechpartner: (id, data) => apiClient.put(`/objekte/ansprechpartner/${id}`, data),
  deleteAnsprechpartner: (id) => apiClient.delete(`/objekte/ansprechpartner/${id}`)
};
